import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getproductlist } from "../service/productlist.service";

export const fetchProductList = createAsyncThunk(
  "product/fetchProductList",
  async (slug, { rejectWithValue }) => {
    try {
      const response = await getproductlist(slug);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

const productSlice = createSlice({
  name: "product",

  initialState: {
    products: [],
    loading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchProductList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchProductList.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload || [];
      })

      .addCase(fetchProductList.rejected, (state, action) => {
        state.loading = false;
        state.products = [];
        state.error = action.payload;
      });
  },
});
export default productSlice.reducer;